(() => {
  const cards = Array.from(document.querySelectorAll('.product-card[data-swatch-source][data-swatch-group]'));
  if (!cards.length) return;

  const fallbackColors = {
    zwart: '#1a1a1a', wit: '#ffffff', blauw: '#2c5282', donkerblauw: '#1e3a8a', navy: '#1a2547',
    lichtblauw: '#93c5fd', rood: '#c0392b', donkerrood: '#7f1d1d', bordeaux: '#5b1a1a', groen: '#16a34a',
    donkergroen: '#14532d', legergroen: '#465f5b', olijf: '#7a8745', sage: '#86b599', bosgroen: '#2f4441',
    lichtgroen: '#86efac', geel: '#f59e0b', roze: '#ec4899', oudroze: '#d4a5a5', paars: '#9333ea',
    donkerpaars: '#544a67', grijs: '#6b7280', donkergrijs: '#374151', lichtgrijs: '#d1d5db', bruin: '#7c2d12',
    omber: '#682b1b', oranje: '#f97316', beige: '#e7d8c2', nude: '#e4c8b4', naturel: '#d8c8a8',
    zand: '#dac8a8', goud: '#d4af37', zilver: '#c0c0c0', turquoise: '#0d9488', kaki: '#a39d6a', khaki: '#a39d6a'
  };

  function render(card, products) {
    const matching = products.filter((product) => product.group === card.dataset.swatchGroup);
    const unique = [];
    const colors = new Set();
    for (const product of matching) {
      if (!product.color || colors.has(product.color)) continue;
      colors.add(product.color);
      unique.push(product);
    }
    if (unique.length < 2) return;

    let container = card.querySelector('.product-card__swatches');
    if (container?.querySelector('.product-card__swatch')) return;
    if (!container) {
      container = document.createElement('div');
      container.className = 'product-card__swatches';
      card.querySelector('.product-card__info')?.append(container);
    }

    for (const product of unique.slice(0, 6)) {
      const swatch = document.createElement('a');
      swatch.href = product.url;
      swatch.className = 'product-card__swatch';
      if (product.transparent) swatch.classList.add('product-card__swatch--transparent');
      if (product.id === card.dataset.productId) swatch.classList.add('is-active');
      if (!product.transparent) swatch.style.backgroundColor = product.hex || fallbackColors[product.color] || '#cccccc';
      swatch.title = product.label;
      swatch.setAttribute('aria-label', product.label);
      container.append(swatch);
    }

    if (unique.length > 6) {
      const more = document.createElement('span');
      more.className = 'product-card__swatch-more';
      more.textContent = `+${unique.length - 6}`;
      container.append(more);
    }
  }

  const sources = new Map();
  for (const card of cards) {
    const sourceCards = sources.get(card.dataset.swatchSource) || [];
    sourceCards.push(card);
    sources.set(card.dataset.swatchSource, sourceCards);
  }

  for (const [url, sourceCards] of sources) {
    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((response) => {
        if (!response.ok) throw new Error(`Swatch request failed: ${response.status}`);
        return response.text();
      })
      .then((html) => {
        const documentFragment = new DOMParser().parseFromString(html, 'text/html');
        const products = Array.from(documentFragment.querySelectorAll('[data-swatch-product]')).map((item) => ({
          id: item.dataset.id,
          url: item.dataset.url,
          group: item.dataset.group,
          color: item.dataset.color,
          label: item.dataset.label,
          hex: item.dataset.hex,
          transparent: item.dataset.transparent === 'true'
        }));
        for (const card of sourceCards) render(card, products);
      })
      .catch(() => {
        /* A failed enhancement leaves the product cards fully usable. */
      });
  }
})();
